import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { CreateDossierForm } from "@/components/CreateDossierDialog";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export default function NewDossierDialog({ onCreated }) {
  const navigate = useNavigate();
  const [path, setPath] = useState(null);

  return (
    <Dialog onOpenChange={(open) => !open && setPath(null)}>
      <DialogTrigger asChild>
        <Button>+ Nouveau dossier</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nouveau dossier</DialogTitle>
        </DialogHeader>

        {path === "formulaire" ? (
          <CreateDossierForm onCreated={onCreated} />
        ) : (
          <div className="space-y-3">
            <Button
              variant="outline"
              className="h-auto w-full justify-start whitespace-normal p-4 text-left"
              onClick={() => setPath("formulaire")}
            >
              <span className="flex flex-col items-start gap-1">
                <span className="font-medium">Avec formulaire client</span>
                <span className="text-sm text-muted-foreground">
                  Le client remplit son formulaire ; on reçoit tout.
                </span>
              </span>
            </Button>
            <Button
              variant="outline"
              className="h-auto w-full justify-start whitespace-normal p-4 text-left"
              onClick={() => navigate("/clients/nouveau/interview")}
            >
              <span className="flex flex-col items-start gap-1">
                <span className="font-medium">Dépôt direct d'une transcription</span>
                <span className="text-sm text-muted-foreground">
                  Le dossier a déjà été interviewé.
                </span>
              </span>
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
